// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    bindActionCreators,
    Dispatch,
} from 'redux';
import { connect } from 'react-redux';
import { RootState } from 'client/core/store';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import * as serverActions from 'common/modules/computeResourceVm/actions';
import * as snapshotActions from 'common/modules/snapshot/actions';
import { SnapshotList } from 'common/components/ServerTabs/SnapshotTab/SnapshotList';
import { hasPermission } from 'common/modules/permission/selectors';
import { PERMISSION_LIST } from 'common/modules/permission/constants';

const mapStateToProps = (state: RootState) => ({
    view: state.app.viewType,
    snapshots: state.snapshots.list.data,
    server: state.project.servers.item,
    isLoading: state.app.loadingFlags.has(LOADING_FLAGS.SNAPSHOTS_LIST),
    canRevertServersSnapshot: hasPermission(
        state,
        PERMISSION_LIST.MANAGE_SERVERS,
        PERMISSION_LIST.REVERT_SERVERS_SNAPSHOT
    ),
    canDeleteServersSnapshot: hasPermission(
        state,
        PERMISSION_LIST.MANAGE_SERVERS,
        PERMISSION_LIST.DELETE_SERVERS_SNAPSHOT
    ),
    serverLimits: state.project.servers.limits,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    snapshotActions: bindActionCreators(snapshotActions, dispatch),
    serverActions: bindActionCreators(serverActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnapshotList);
